export default "__VITE_ASSET__BFUwm1mW__"